(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const el = document.querySelector('.ai-box-panel');
    if (!el) return;

    const tenant_id = '6a26c776a532a96294d8382d';

    const CHATS_ENDPOINT =
      `https://api-ai.textyess.com/onsite-chats/organization/${tenant_id}/chats`;
    
    const COMPLETIONS_ENDPOINT = 'https://brain.textyess.com/ai/chat/completions'
    
    let chatId = null;
    const conversationMessages = [];

    const field = el.querySelector('.ai-box__field');
    const input = el.querySelector('.ai-box__input');
    const animatedPlaceholder = el.querySelector('.ai-box__placeholder');
    const submitButton = el.querySelector('.ai-box__icon');
    const trigger = el.querySelector('.ai-box__trigger');
    const overlay = el.querySelector('.ai-box-panel__overlay');
    const contentInner = el.querySelector('.ai-box__content-inner');
    const contentBody = el.querySelector('.ai-box__content-body');
    const conversationHeader = el.querySelector('.ai-box__conversation-header');
    const headerDisclosure = el.querySelector('.ai-box__header-disclosure');
    const headerDisclosureToggle = el.querySelector('.ai-box__header-disclosure-toggle');
    let headerDisclosureAnimation = null;
    const closeButton = el.querySelector('.ai-box__close');

    // Page links open in a new tab; store product, mailto, tel and same-page links stay in the current tab.
    const openPageLinksInNewTab = (root) => {
      root?.querySelectorAll('a[href]').forEach((link) => {
        const href = link.getAttribute('href');
        if (/^(mailto:|tel:|#)/i.test(href)) return;
        let url;
        try {
          url = new URL(href, window.location.origin);
        } catch (_error) {
          return;
        }
        const isStoreUrl =
          url.origin === window.location.origin || url.hostname === el.dataset.shopPermanentDomain;
        if (isStoreUrl && url.pathname.includes('/products/')) return;
        link.target = '_blank';
        link.rel = 'noopener';
      });
    };
    openPageLinksInNewTab(el);

    const welcomeContent = contentBody ? contentBody.innerHTML : '';
    const thinkingTemplate = el.querySelector('.ai-box__thinking-template');
    const productPriceTemplate = el.querySelector('.ai-box__product-price-template');
    const status = el.querySelector('.ai-box__status');
    const welcomePreviewTrigger = el.querySelector('.ai-box__welcome-preview-trigger');
    const recommendationBuyBoxHost = document.querySelector('.ai-box__recommendation-buy-box-host');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pagePolicy = el.dataset.aiPagePolicy || 'standard';
    const pushChatbotInteraction = (action, details = {}) => {
      window.dataLayer = window.dataLayer || [];
      const payload = {
        event: 'chatbot_interaction',
        action,
        ...details,
      };

      window.dataLayer.push(payload);
    };

    const RECOMMENDATION_LIST = {
      item_list_id: 'ai_companion_recommendations',
      item_list_name: 'AI Companion Recommendations',
    };

    const pushAiEvent = (payload) => {
      window.dataLayer = window.dataLayer || [];
      if (payload?.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    };

    let chatOpenedAt = null;

    const trackChatOpened = (entryPoint) => {
      chatOpenedAt = Date.now();
      pushChatbotInteraction('chat_opened', { entry_point: entryPoint });
    };

    const trackChatEnd = (isExplicitClose) => {
      if (chatOpenedAt === null) return;
      const elapsedSeconds = Math.round((Date.now() - chatOpenedAt) / 1000);
      chatOpenedAt = null;
      pushChatbotInteraction('chat_end', {
        chat_elapsed_time_sec: elapsedSeconds,
        is_explicit_close: isExplicitClose,
      });
    };

    const getRecommendationItemCategory = (productType) => {
      const rawValue = String(productType || '').trim();
      if (!rawValue) return 'Nekua Blends';

      const normalized = rawValue.toLowerCase();
      if (normalized.includes('stack')) return 'Nekua Stacks';
      if (normalized.includes('gift')) return 'Gift';
      if (normalized.includes('sample')) return 'Sample-Stick';
      if (normalized.includes('addon')) return 'Addon';
      if (normalized.includes('welcome')) return 'Welcome kit';

      return rawValue;
    };

    const getRecommendationItem = (product) => {
      const handle = getRecommendationHandle(product);
      const shopifyProduct = recommendationProducts.get(handle);
      const variant = shopifyProduct?.variants?.find((entry) => entry.available) || shopifyProduct?.variants?.[0];
      const title = recommendationProductTitles.get(handle) || shopifyProduct?.title;
      if (!handle || !title) return null;

      const recommendationPrice = Number.parseFloat(
        String(product?.price_min || '').replace(/[^0-9,.-]/g, '').replace(',', '.')
      );
      const variantPrice = Number(variant?.price) / 100;
      const price = Number.isFinite(recommendationPrice)
        ? recommendationPrice
        : Number.isFinite(variantPrice)
          ? variantPrice
          : 0;
      const compareAtPrice = Number(variant?.compare_at_price || 0) / 100;
      const discount = compareAtPrice > price ? Number((compareAtPrice - price).toFixed(2)) : 0;
      const discountPercent = compareAtPrice > price ? Math.round((discount / compareAtPrice) * 100) : 0;
      const purchasePlan = 'one_time';
      const itemId = recommendationProductIds.get(handle) || String(shopifyProduct?.id || handle);
      const badgeType = window.nekuaTracking?.getBadgeTypeForProduct?.(itemId) || null;

      return {
        item_id: itemId,
        item_name: title,
        item_category: getRecommendationItemCategory(shopifyProduct?.type),
        item_brand: shopifyProduct?.vendor || 'Nekua',
        price,
        purchase_plan: purchasePlan,
        discount_percent: discountPercent,
        badge_type: badgeType,
        item_category2: badgeType || '',
        item_category3: discountPercent,
        item_variant: purchasePlan,
        discount,
        quantity: 1,
      };
    };

    // The AI payload only carries handles; the rest of the theme reports numeric product ids.
    const recommendationProductIds = new Map();
    const recommendationProducts = new Map();
    const recommendationProductTitles = new Map();

    const resolveRecommendationProductId = async (handle) => {
      if (!handle || recommendationProductIds.has(handle)) return;

      const rootUrl = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${rootUrl}products/${handle}.js`);
        if (!response.ok) return;

        const product = await response.json();
        recommendationProducts.set(handle, product);
        if (product?.id) recommendationProductIds.set(handle, String(product.id));
        if (product?.title) {
          const type = String(product.type || '').toLowerCase();
          let name = product.title;
          if (type.includes('stack') || type.includes('bundle')) {
            const sectionResponse = await fetch(getRecommendationSectionUrl(handle));
            if (sectionResponse.ok) {
              const markup = await sectionResponse.text();
              const fragment = document.createRange().createContextualFragment(markup);
              name = fragment.querySelector('buy-box-panel')?.dataset.trackingProductTitle || name;
            }
          }
          recommendationProductTitles.set(handle, name);
        }
      } catch (_error) {
        // Tracking must never break the conversation; the handle stays as the fallback id.
      }
    };

    const withRecommendationListContext = (item, index) => ({
      ...item,
      ...RECOMMENDATION_LIST,
      index: index,
    });

    const readDurationToken = (name, fallback) => {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim();
      const duration = Number.parseFloat(value);
      return Number.isFinite(duration) ? duration * (value.endsWith('ms') ? 1 : 1000) : fallback;
    };
    const blockingSurfaceTransitionDuration = readDurationToken('--blocking-surface-transition-duration', 800);
    const blockingSurfaceContentTransitionDuration = readDurationToken(
      '--blocking-surface-content-transition-duration',
      300
    );
    const blockingSurfaceTransitionEasing = getComputedStyle(document.documentElement)
      .getPropertyValue('--blocking-surface-transition-easing')
      .trim() || 'ease-in-out';

    if (overlay) document.body.appendChild(overlay);
    if (pagePolicy === 'product') {
      let surfaceStack = document.querySelector('.product-surface-stack');
      if (!surfaceStack) {
        surfaceStack = document.createElement('div');
        surfaceStack.className = 'product-surface-stack';
        const surfaceAnchor = document.querySelector('.product-details__details')?.closest('.shopify-section');
        if (surfaceAnchor) surfaceAnchor.after(surfaceStack);
        else document.body.insertBefore(surfaceStack, document.querySelector('body > footer'));
      }
      surfaceStack.appendChild(el);
    } else {
      document.body.appendChild(el);
    }

    const isLoggedIn = el.dataset.loggedIn === 'true';
    const storedConversationId = el.dataset.conversationId || null;
    const conversationSaveUrl = el.dataset.conversationSaveUrl || null;
    const customerSecretKey = el.dataset.customerSecretKey || null;
    const guestConversationStorageKey = 'nekua_ai_conversation_id';
    const heroSection = pagePolicy === 'nekua-ai'
      ? document.querySelector('[data-nekua-ai-hero]')
      : null;
    const heroEntryTrigger = heroSection
      ? heroSection.querySelector('[data-hero-ai-entry-trigger]')
      : null;
    const heroPlaceholder = heroSection
      ? heroSection.querySelector('[data-hero-ai-entry] .ai-box__placeholder')
      : null;
    const welcomeMediaVideos = el.querySelectorAll('.ai-box__welcome-media video');
    let isHeroInView = false;
    if (heroSection) {
      const heroRect = heroSection.getBoundingClientRect();
      isHeroInView = heroRect.bottom > 0 && heroRect.top < window.innerHeight;
    }
    const syncWelcomeMediaPlayback = () => {
      const shouldPlay =
        !prefersReducedMotion.matches &&
        el.classList.contains('is-expanded') &&
        !el.classList.contains('is-input-focused') &&
        !el.hasAttribute('inert');
      welcomeMediaVideos.forEach((video) => {
        if (shouldPlay) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    };
    const storefrontRoot = el.dataset.storefrontRoot || '/';
    const recommendationMessages = {
      preparing: el.dataset.recommendationPreparingLabel,
      failed: el.dataset.recommendationFailedLabel,
      unavailable: el.dataset.recommendationUnavailableLabel,
      retry: el.dataset.recommendationRetryLabel,
    };
    const uiLabels = {
      recommendTitle: el.dataset.recommendTitle || '',
      pricePrefix: el.dataset.pricePrefix || '',
      historyLoading: el.dataset.historyLoadingLabel || '',
      historyError: el.dataset.historyErrorLabel || '',
      answerError: el.dataset.answerErrorLabel || '',
      retry: el.dataset.retryLabel || '',
      persistenceRetry: el.dataset.persistenceRetryLabel || '',
    };

    const updateEntryHeight = () => {
      if (!field || el.classList.contains('is-modal-open')) return;
      const panelStyles = window.getComputedStyle(el);
      const panelChrome =
        parseFloat(panelStyles.paddingTop) +
        parseFloat(panelStyles.paddingBottom) +
        parseFloat(panelStyles.borderTopWidth) +
        parseFloat(panelStyles.borderBottomWidth);
      document.documentElement.style.setProperty(
        '--ai-box-entry-height',
        `${field.offsetHeight + panelChrome}px`
      );
    };
    const entryResizeObserver = new ResizeObserver(updateEntryHeight);
    if (field) entryResizeObserver.observe(field);
    updateEntryHeight();

    if (isLoggedIn) {
      try {
        window.localStorage.removeItem(guestConversationStorageKey);
      } catch (error) {
        console.error('Failed to clear guest conversation id:', error);
      }
    }

    const getGuestConversationId = () => {
      if (isLoggedIn) return null;

      try {
        return window.localStorage.getItem(guestConversationStorageKey);
      } catch (error) {
        console.error('Failed to read guest conversation id:', error);
        return null;
      }
    };

    const guestConversationId = getGuestConversationId();
    const conversationId = storedConversationId || guestConversationId;
    let hasSavedConversation = Boolean(conversationId);
    const isGuestConversation = !storedConversationId && Boolean(guestConversationId);

    let hasStarted = false;
    let historyState = hasSavedConversation ? 'pending' : 'none';
    let isExchangeInFlight = false;
    let failedExchange = null;
    const persistenceQueue = [];
    const persistenceRetryDelays = [1000, 2000, 4000];
    let isPersisting = false;
    let persistenceRetryTimer = null;
    let persistenceRetryButton = null;
    let isPersistenceRetryExhausted = false;
    let activeTrigger = null;
    let isModalOpen = false;
    let isModalOpening = false;
    let isModalTransitioning = false;
    let modalTransitionTimer = null;
    let welcomePreviewTransitionTimer = null;
    let welcomePreviewAnimation = null;
    let recommendationPreparation = null;
    let activeRecommendationBuyBox = null;
    let activeRecommendationTerminalListener = null;
    let recommendationFeedback = null;
    let productSurfaceReleaseTimer = null;
    let isRestoringFocus = false;
    let lastPointerTarget = null;
    let lastKey = '';
    let lastInteractionTime = -Infinity;
    let previousDocumentOverflow = '';
    let wasAtHomepageTop = window.scrollY <= 16;
    const unavailablePageChildren = new Set();

    const placeholderMessages = animatedPlaceholder
      ? [
          animatedPlaceholder.dataset.placeholderPrimary,
          animatedPlaceholder.dataset.placeholderSecondary,
          animatedPlaceholder.dataset.placeholderTertiary,
        ].filter(Boolean)
      : [];
    let placeholderIndex = 0;
    let placeholderRotationTimer = null;
    let placeholderTransitionTimer = null;

    const buildPlaceholderLetters = () =>
      Array.from(placeholderMessages[placeholderIndex], (letter, index) => {
        const letterEl = document.createElement('span');
        letterEl.className = 'ai-box__placeholder-letter';
        letterEl.style.setProperty('--letter-index', index);
        letterEl.textContent = letter;
        return letterEl;
      });

    const renderAnimatedPlaceholder = () => {
      if (!animatedPlaceholder || !placeholderMessages.length) return;
      const letters = buildPlaceholderLetters();
      animatedPlaceholder.replaceChildren(...letters);
      if (heroPlaceholder) {
        heroPlaceholder.replaceChildren(...letters.map((node) => node.cloneNode(true)));
      }
    };

    const updateAnimatedPlaceholderVisibility = () => {
      el.classList.toggle(
        'is-placeholder-visible',
        Boolean(input && !input.value && (!isModalOpen || document.activeElement !== input))
      );
    };

    if (animatedPlaceholder && placeholderMessages.length) {
      renderAnimatedPlaceholder();
      if (placeholderMessages.length > 1) {
        placeholderRotationTimer = window.setInterval(() => {
          animatedPlaceholder.classList.add('is-transitioning');
          heroPlaceholder?.classList.add('is-transitioning');
          placeholderTransitionTimer = window.setTimeout(() => {
            placeholderIndex = (placeholderIndex + 1) % placeholderMessages.length;
            renderAnimatedPlaceholder();
            animatedPlaceholder.classList.remove('is-transitioning');
            heroPlaceholder?.classList.remove('is-transitioning');
          }, 400);
        }, 6000);
      }
    }

    const setStatus = (message) => {
      if (status) status.textContent = message;
    };

    const updatePersistenceStatus = (message, canRetry = false) => {
      setStatus(message);

      if (!contentBody) return;
      if (!persistenceRetryButton && canRetry) {
        persistenceRetryButton = document.createElement('button');
        persistenceRetryButton.type = 'button';
        persistenceRetryButton.className = 'ai-box__persistence-retry';
        persistenceRetryButton.textContent = uiLabels.persistenceRetry;
        persistenceRetryButton.addEventListener('click', () => {
          persistenceQueue.forEach((exchange) => {
            exchange.retryAttempt = 0;
          });
          isPersistenceRetryExhausted = false;
          persistenceRetryButton?.remove();
          persistenceRetryButton = null;
          processPersistenceQueue();
        });
        contentBody.appendChild(persistenceRetryButton);
      }

      if (!canRetry && persistenceRetryButton) {
        persistenceRetryButton.remove();
        persistenceRetryButton = null;
      }
    };

    const setMessagingEnabled = (enabled) => {
      if (input) input.disabled = !enabled;
      setSubmissionEnabled(!isExchangeInFlight);
    };

    const setSubmissionEnabled = (enabled) => {
      const submissionAvailable = Boolean(enabled && isModalOpen && input && !input.disabled);
      if (submitButton) submitButton.disabled = !submissionAvailable;
      el.classList.toggle('is-exchange-in-flight', !enabled);
      if (submitButton) {
        submitButton.setAttribute(
          'aria-label',
          enabled ? el.dataset.sendLabel : el.dataset.sendPendingLabel
        );
      }
    };

    const showHistoryLoading = () => {
      if (!contentBody) return;
      contentBody.innerHTML = '';
      const loadingEl = document.createElement('p');
      loadingEl.className = 'ai-box__loading';
      loadingEl.textContent = uiLabels.historyLoading;
      contentBody.appendChild(loadingEl);
      setStatus(uiLabels.historyLoading);
    };

    const showHistoryError = (retry) => {
      historyState = 'failed';
      if (!contentBody) return;
      contentBody.innerHTML = '';
      const errorEl = document.createElement('p');
      errorEl.className = 'ai-box__loading';
      errorEl.textContent = uiLabels.historyError;
      const retryButton = document.createElement('button');
      retryButton.type = 'button';
      retryButton.className = 'ai-box__hint';
      retryButton.textContent = uiLabels.retry;
      retryButton.addEventListener('click', () => {
        historyState = 'pending';
        showHistoryLoading();
        retry();
      });
      contentBody.append(errorEl, retryButton);
      setStatus(uiLabels.historyError);
    };

    const restoreFreshConversation = () => {
      historyState = 'none';
      chatId = null;
      if (contentBody) contentBody.innerHTML = welcomeContent;
      setMessagingEnabled(true);
      setStatus('');
      if (isModalOpen) {
        expand();
        focusFirstControl();
        return;
      }
      applyWelcomePreviewPolicy();
    };

    const setPageAvailability = (available) => {
      // The product surfaces sit inside <main>: block everything beside each ancestor on the way up, never the ancestors.
      let node = el.closest('.product-surface-stack') || el;
      while (node && node !== document.body) {
        const current = node;
        Array.from(current.parentElement.children).forEach((child) => {
          if (child === current || child === overlay || child.tagName === 'SCRIPT') return;
          if (available) {
            if (unavailablePageChildren.has(child)) child.removeAttribute('inert');
          } else if (!child.hasAttribute('inert')) {
            child.setAttribute('inert', '');
            unavailablePageChildren.add(child);
          }
        });
        node = current.parentElement;
      }
      if (available) unavailablePageChildren.clear();
    };

    const focusFirstControl = () => {
      window.requestAnimationFrame(() => {
        if (isModalOpen && input && !input.disabled) input.focus();
      });
    };

    const isTouchInput = () => window.matchMedia('(pointer: coarse)').matches;

    // Keep the open box inside the visible area when the on-screen keyboard covers part of the viewport.
    const syncVisualViewport = () => {
      const viewport = window.visualViewport;
      if (!viewport) return;
      const keyboardInset = Math.max(
        0,
        document.documentElement.clientHeight - viewport.offsetTop - viewport.height
      );
      document.documentElement.style.setProperty('--ai-box-viewport-height', `${viewport.height}px`);
      document.documentElement.style.setProperty('--ai-box-keyboard-inset', `${keyboardInset}px`);
      // Toolbar changes are well under 150px; an on-screen keyboard is well over it
      el.classList.toggle('is-keyboard-open', document.documentElement.clientHeight - viewport.height > 150);
    };
    const trackVisualViewport = (track) => {
      const viewport = window.visualViewport;
      if (!viewport) return;
      const method = track ? 'addEventListener' : 'removeEventListener';
      viewport[method]('resize', syncVisualViewport);
      viewport[method]('scroll', syncVisualViewport);
      if (track) syncVisualViewport();
      else el.classList.remove('is-keyboard-open');
    };
    const clearVisualViewport = () => {
      document.documentElement.style.removeProperty('--ai-box-viewport-height');
      document.documentElement.style.removeProperty('--ai-box-keyboard-inset');
    };

    const collapse = () => {
      el.classList.remove('is-expanded');
      syncWelcomeMediaPlayback();
    };

    const expand = () => {
      el.classList.add('is-expanded');
      syncWelcomeMediaPlayback();
      // A first conversation reads from the top of the welcome; a resumed one opens on its latest message
      if (!hasStarted && historyState === 'none') {
        if (contentInner) contentInner.scrollTop = 0;
      } else {
        scrollConversationToBottom();
      }
    };

    const getCollapsedPanelHeight = () => {
      if (!field) return el.getBoundingClientRect().height;
      const panelStyles = window.getComputedStyle(el);
      return field.offsetHeight +
        parseFloat(panelStyles.paddingTop) +
        parseFloat(panelStyles.paddingBottom) +
        parseFloat(panelStyles.borderTopWidth) +
        parseFloat(panelStyles.borderBottomWidth);
    };

    const finishWelcomePreviewTransition = () => {
      el.style.height = '';
      el.classList.remove('is-welcome-preview-transitioning');
      welcomePreviewTransitionTimer = null;
      welcomePreviewAnimation = null;
      applyWelcomePreviewPolicy();
    };

    // Explicit keyframes: iOS Safari skipped the CSS height transition here
    const animateWelcomePreviewHeight = (fromHeight, toHeight) => {
      const duration = prefersReducedMotion.matches ? 0 : blockingSurfaceTransitionDuration;
      if (duration) {
        welcomePreviewAnimation = el.animate(
          { height: [`${fromHeight}px`, `${toHeight}px`] },
          { duration, easing: blockingSurfaceTransitionEasing }
        );
      }
      welcomePreviewTransitionTimer = window.setTimeout(finishWelcomePreviewTransition, duration);
    };

    const collapseWelcomePreview = () => {
      if (!el.classList.contains('is-expanded') || welcomePreviewTransitionTimer) return;

      el.classList.add('is-welcome-preview-transitioning');
      welcomePreviewTransitionTimer = window.setTimeout(() => {
        const expandedHeight = el.getBoundingClientRect().height;
        collapse();
        animateWelcomePreviewHeight(expandedHeight, getCollapsedPanelHeight());
      }, prefersReducedMotion.matches ? 0 : blockingSurfaceContentTransitionDuration);
    };

    const expandWelcomePreview = () => {
      if (el.classList.contains('is-expanded') || welcomePreviewTransitionTimer) return;

      el.classList.add('is-welcome-preview-transitioning');
      const collapsedHeight = el.getBoundingClientRect().height;
      expand();
      animateWelcomePreviewHeight(collapsedHeight, el.getBoundingClientRect().height);
    };

    const canShowWelcomePreview = () =>
      !hasStarted && historyState === 'none' && pagePolicy === 'home' && window.scrollY <= 16;

    const applyWelcomePreviewPolicy = () => {
      const isScrolled = window.scrollY > 16;
      el.classList.toggle('is-scrolled', isScrolled);
      // Opening or open: the modal owns the box size (iOS scrolls the page when the keyboard appears)
      if (isModalOpen || isModalOpening) {
        syncWelcomeMediaPlayback();
        return;
      }
      if (!canShowWelcomePreview()) {
        collapseWelcomePreview();
        syncWelcomeMediaPlayback();
        return;
      }
      expandWelcomePreview();
      syncWelcomeMediaPlayback();
    };

    // Nekua AI page AI welcome policy: withhold the collapsed sticky AI entry while the hero intersects the viewport.
    const applyNekuaAiWelcomePolicy = () => {
      if (pagePolicy !== 'nekua-ai') return;
      const withholdSticky = Boolean(heroSection && isHeroInView && !isModalOpen);
      el.toggleAttribute('inert', withholdSticky);
      if (heroEntryTrigger) {
        heroEntryTrigger.setAttribute('aria-expanded', String(isModalOpen));
      }
      syncWelcomeMediaPlayback();
    };

    const canRestoreFocusTo = (node) =>
      Boolean(
        node &&
        node.isConnected &&
        typeof node.focus === 'function' &&
        !node.closest('[inert]') &&
        node.getClientRects().length &&
        // The collapsed content is hidden, so its preview trigger cannot take focus
        (node !== welcomePreviewTrigger || el.classList.contains('is-expanded'))
      );

    const announceProductSurface = (type, detail = {}) => {
      if (pagePolicy !== 'product') return detail;
      document.dispatchEvent(new CustomEvent(type, { detail }));
      return detail;
    };

    const handleBuyBoxOpening = (event) => {
      if (event.detail?.recommendation) return;
      if (isModalOpen) {
        closeModal(false);
        return;
      }
      // Still waiting for the buy box to collapse: abandon the opening instead of opening over it
      if (!isModalOpening) return;
      window.clearTimeout(modalTransitionTimer);
      modalTransitionTimer = null;
      isModalOpening = false;
      isModalTransitioning = false;
      el.classList.remove('is-modal-transitioning');
      el.style.height = '';
      trackVisualViewport(false);
      clearVisualViewport();
      if (el.contains(document.activeElement)) document.activeElement.blur();
      restorePassivePresentation();
      announceProductSurface('ai-box:closed');
    };

    const isValidProductHandle = (handle) =>
      typeof handle === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle);

    const getRecommendationHandle = (product) => {
      const payloadHandle = typeof product?.handle === 'string' ? product.handle : '';
      if (isValidProductHandle(payloadHandle)) return payloadHandle;

      if (typeof product?.product_url !== 'string') return '';
      try {
        const productUrl = new URL(product.product_url, window.location.origin);
        const root = storefrontRoot.endsWith('/') ? storefrontRoot : `${storefrontRoot}/`;
        const productsPath = new URL(`products/`, new URL(root, window.location.origin)).pathname;
        const isCurrentStorefront = productUrl.origin === window.location.origin;
        const isShopifyStorefront = productUrl.hostname.endsWith('.myshopify.com');
        // AI payload URLs may lack the locale prefix (e.g. /products/x while browsing /en).
        const matchedPath = [productsPath, '/products/'].find((path) => productUrl.pathname.startsWith(path));
        if ((!isCurrentStorefront && !isShopifyStorefront) || !matchedPath) {
          return '';
        }
        const urlHandle = decodeURIComponent(productUrl.pathname.slice(matchedPath.length));
        return isValidProductHandle(urlHandle) ? urlHandle : '';
      } catch (_error) {
        return '';
      }
    };

    const getRecommendationSectionUrl = (handle, sectionId = 'product-buy-box') => {
      const root = storefrontRoot.endsWith('/') ? storefrontRoot : `${storefrontRoot}/`;
      const url = new URL(`products/${handle}`, new URL(root, window.location.origin));
      url.searchParams.set('section_id', sectionId);
      return url;
    };

    const recommendationDisplayNames = new Map();
    const resolveRecommendationDisplayName = (handle) => {
      if (!recommendationDisplayNames.has(handle)) {
        recommendationDisplayNames.set(
          handle,
          fetch(getRecommendationSectionUrl(handle, 'ai-product-name'))
            .then((response) => (response.ok ? response.text() : ''))
            .then((markup) => document.createRange().createContextualFragment(markup).textContent.trim())
            .catch(() => '')
        );
      }
      return recommendationDisplayNames.get(handle);
    };

    const restoreRecommendationConversation = (activator, scrollPosition) => {
      if (!isModalOpen) return;
      if (contentInner) contentInner.scrollTop = scrollPosition;
      window.requestAnimationFrame(() => {
        if (contentInner) contentInner.scrollTop = scrollPosition;
        if (activator?.isConnected) activator.focus();
      });
    };

    const setRecommendationPricesAvailable = (available, busyActivator = null) => {
      contentBody?.querySelectorAll('[data-recommendation-handle]').forEach((price) => {
        const isBusy = !available && price === busyActivator;
        price.disabled = !available;
        price.setAttribute('aria-disabled', String(!available));
        if (isBusy) {
          price.setAttribute('aria-busy', 'true');
        } else {
          price.removeAttribute('aria-busy');
        }
        if (available) {
          price.removeAttribute('tabindex');
        } else {
          price.setAttribute('tabindex', '-1');
        }
      });
    };

    const clearRecommendationFeedback = () => {
      recommendationFeedback?.remove();
      recommendationFeedback = null;
    };

    const clearRecommendationBuyBox = () => {
      if (activeRecommendationTerminalListener) {
        document.removeEventListener('buy-box:terminal', activeRecommendationTerminalListener);
        activeRecommendationTerminalListener = null;
      }
      document
        .querySelector('buy-box-panel:not([data-temporary])')
        ?.removeAttribute('data-recommendation-active');
      activeRecommendationBuyBox?.removeTemporary();
      activeRecommendationBuyBox = null;
      recommendationBuyBoxHost?.replaceChildren();
    };

    const completeRecommendationPreparation = (preparation) => {
      if (recommendationPreparation !== preparation) return false;
      recommendationPreparation = null;
      setRecommendationPricesAvailable(true);
      return true;
    };

    const showRecommendationOutcome = (preparation, outcome) => {
      if (!completeRecommendationPreparation(preparation) || !isModalOpen) return;
      clearRecommendationFeedback();

      const feedback = document.createElement('div');
      feedback.className = 'ai-box__recommendation-feedback';
      feedback.setAttribute('role', 'status');
      const message = document.createElement('p');
      message.textContent = recommendationMessages[outcome] || recommendationMessages.failed;
      feedback.appendChild(message);

      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'ai-box__persistence-retry';
      retry.textContent = recommendationMessages.retry;
      retry.addEventListener('click', () => {
        feedback.remove();
        if (recommendationFeedback === feedback) recommendationFeedback = null;
        openRecommendationBuyBox(preparation.handle, preparation.activator);
      });
      feedback.appendChild(retry);
      recommendationFeedback = feedback;
      preparation.activator.closest('.ai-box__product-info')?.appendChild(feedback);
      setStatus(message.textContent);
    };

    const cancelRecommendationPreparation = () => {
      const preparation = recommendationPreparation;
      if (!preparation) return;
      console.debug('[ai-box][recommendation] preparation cancelled', { handle: preparation.handle });
      recommendationPreparation = null;
      preparation.controller.abort();
      setRecommendationPricesAvailable(true);
    };

    const openRecommendationBuyBox = async (handle, activator) => {
      if (
        !recommendationBuyBoxHost ||
        !isModalOpen ||
        recommendationPreparation ||
        activeRecommendationBuyBox
      ) {
        console.debug('[ai-box][recommendation] preparation ignored', {
          handle,
          hasHost: Boolean(recommendationBuyBoxHost),
          isModalOpen,
          preparationActive: Boolean(recommendationPreparation),
          buyBoxActive: Boolean(activeRecommendationBuyBox),
        });
        return;
      }

      const preparation = {
        activator,
        controller: new AbortController(),
        handle,
        scrollPosition: contentInner?.scrollTop || 0,
      };
      recommendationPreparation = preparation;
      clearRecommendationFeedback();
      setRecommendationPricesAvailable(false, activator);
      setStatus(recommendationMessages.preparing);
      console.debug('[ai-box][recommendation] preparation started', { handle });

      if (!isValidProductHandle(handle)) {
        console.warn('[ai-box][recommendation] invalid product handle', { handle });
        showRecommendationOutcome(preparation, 'failed');
        return;
      }

      try {
        const response = await fetch(getRecommendationSectionUrl(handle), {
          headers: { Accept: 'text/html' },
          signal: preparation.controller.signal,
        });
        if (!response.ok) {
          console.error('[ai-box][recommendation] section request failed', {
            handle,
            status: response.status,
            url: response.url,
          });
          showRecommendationOutcome(preparation, 'failed');
          return;
        }

        const markup = await response.text();
        if (!markup.trim() || recommendationPreparation !== preparation || !isModalOpen) {
          console.warn('[ai-box][recommendation] section response discarded', {
            handle,
            hasMarkup: Boolean(markup.trim()),
            ownsPreparation: recommendationPreparation === preparation,
            isModalOpen,
          });
          if (recommendationPreparation === preparation) showRecommendationOutcome(preparation, 'failed');
          return;
        }

        const fragment = document.createRange().createContextualFragment(markup);
        const buyBoxes = fragment.querySelectorAll('buy-box-panel');
        const buyBox = buyBoxes.length === 1 ? buyBoxes[0] : null;
        if (!buyBox || buyBox.dataset.productHandle !== handle) {
          console.error('[ai-box][recommendation] section markup has no matching buy box', {
            handle,
            buyBoxCount: buyBoxes.length,
            renderedHandle: buyBox?.dataset.productHandle,
          });
          showRecommendationOutcome(preparation, 'failed');
          return;
        }

        if (!buyBox.querySelector('[data-buy-box-atc]')) {
          console.error('[ai-box][recommendation] section markup has no add-to-cart control', { handle });
          showRecommendationOutcome(preparation, 'failed');
          return;
        }
        if (!completeRecommendationPreparation(preparation) || !isModalOpen) return;

        activeRecommendationBuyBox = buyBox;
        document
          .querySelector('buy-box-panel:not([data-temporary])')
          ?.setAttribute('data-recommendation-active', '');
        buyBox.setAttribute('data-temporary', '');
        buyBox.setAttribute('data-recommendation-buy-box', '');
        const availabilityReady = new Promise((resolve) => {
          buyBox.addEventListener('buy-box:availability-ready', resolve, { once: true });
        });
        recommendationBuyBoxHost.replaceChildren(fragment);
        await availabilityReady;
        console.debug('[ai-box][recommendation] buy box availability ready', {
          handle,
          connected: buyBox.isConnected,
          addToCartDisabled: buyBox.querySelector('[data-buy-box-atc]')?.disabled,
          openPurchaseSurface: typeof buyBox.openPurchaseSurface,
        });
        if (activeRecommendationBuyBox !== buyBox || !isModalOpen) return;
        if (buyBox.querySelector('[data-buy-box-atc]')?.disabled) {
          console.info('[ai-box][recommendation] product is unavailable', { handle });
          clearRecommendationBuyBox();
          setRecommendationPricesAvailable(true);
          const unavailablePreparation = { ...preparation, controller: new AbortController() };
          recommendationPreparation = unavailablePreparation;
          showRecommendationOutcome(unavailablePreparation, 'unavailable');
          return;
        }
        if (typeof buyBox.openPurchaseSurface !== 'function') {
          console.error('[ai-box][recommendation] buy box did not initialize', { handle });
          clearRecommendationBuyBox();
          const failedPreparation = { ...preparation, controller: new AbortController() };
          recommendationPreparation = failedPreparation;
          showRecommendationOutcome(failedPreparation, 'failed');
          return;
        }
        buyBox.openPurchaseSurface();
        console.debug('[ai-box][recommendation] buy box opened', { handle });

        const onTerminal = (event) => {
          if (event.target !== buyBox) return;
          clearRecommendationBuyBox();
          if (event.detail?.outcome === 'abandoned') {
            restoreRecommendationConversation(preparation.activator, preparation.scrollPosition);
          }
        };
        activeRecommendationTerminalListener = onTerminal;
        document.addEventListener('buy-box:terminal', onTerminal);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('[ai-box][recommendation] preparation failed unexpectedly', {
          handle,
          error,
        });
        showRecommendationOutcome(preparation, 'failed');
      }
    };

    const openModal = (activator, entryPoint = 'floating_widget') => {
      if (isModalOpen || isModalTransitioning) return;

      isModalOpening = true;
      // Stop any welcome-preview resize in place; the modal grows from the current height
      if (welcomePreviewAnimation) el.style.height = `${el.getBoundingClientRect().height}px`;
      welcomePreviewAnimation?.cancel();
      welcomePreviewAnimation = null;
      window.clearTimeout(welcomePreviewTransitionTimer);
      welcomePreviewTransitionTimer = null;
      el.classList.remove('is-welcome-preview-transitioning');
      trackVisualViewport(true);
      trackChatOpened(entryPoint);

      const opensFromWelcome =
        historyState === 'none' &&
        !hasStarted &&
        el.classList.contains('is-expanded');

      const finishOpening = () => {
        if (opensFromWelcome) {
          el.style.height = `${el.getBoundingClientRect().height}px`;
        }

        if (productSurfaceReleaseTimer) {
          window.clearTimeout(productSurfaceReleaseTimer);
          productSurfaceReleaseTimer = null;
        }
        const openingDetail = announceProductSurface('ai-box:opening', { buyBoxCollapseDelay: 0 });
        const beginModalExpansion = () => {
          activeTrigger = activator || document.activeElement;
          isModalOpen = true;
          applyNekuaAiWelcomePolicy();
          previousDocumentOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          el.classList.add('is-modal-open', 'is-input-focused');
          updateAnimatedPlaceholderVisibility();
          setSubmissionEnabled(!isExchangeInFlight);
          el.setAttribute('role', 'dialog');
          el.setAttribute('aria-modal', 'true');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          if (welcomePreviewTrigger) welcomePreviewTrigger.setAttribute('aria-expanded', 'true');
          if (heroEntryTrigger) heroEntryTrigger.setAttribute('aria-expanded', 'true');
          if (overlay) overlay.classList.add('is-visible');
          setPageAvailability(false);
          expand();
          if (historyState === 'pending') showHistoryLoading();
          updateConversationHeader();

          window.requestAnimationFrame(() => {
            el.style.height = '';
            // Fade the conversation in as the panel settles
            modalTransitionTimer = window.setTimeout(() => {
              el.classList.add('is-modal-content-visible');
              isModalOpening = false;
              el.classList.remove('is-modal-transitioning');
              isModalTransitioning = false;
              modalTransitionTimer = null;
              focusFirstControl();
            }, prefersReducedMotion.matches ? 0 : blockingSurfaceTransitionDuration - blockingSurfaceContentTransitionDuration);
          });
        };

        const collapseDelay = prefersReducedMotion.matches ? 0 : openingDetail.buyBoxCollapseDelay;
        if (collapseDelay) {
          modalTransitionTimer = window.setTimeout(beginModalExpansion, collapseDelay);
        } else {
          beginModalExpansion();
        }
      };

      isModalTransitioning = true;
      if (opensFromWelcome) {
        el.classList.add('is-modal-transitioning');
        modalTransitionTimer = window.setTimeout(
          finishOpening,
          prefersReducedMotion.matches ? 0 : blockingSurfaceContentTransitionDuration
        );
        return;
      }

      el.classList.add('is-modal-transitioning');
      finishOpening();
    };

    const restorePassivePresentation = () => {
      el.classList.remove('is-input-focused');
      applyWelcomePreviewPolicy();
    };

    const setHeaderDisclosureExpanded = (expanded, animate = true) => {
      if (!headerDisclosure || !headerDisclosureToggle) return;
      const headerDisclosureContent = headerDisclosure.querySelector('.ai-box__header-disclosure-content');
      const startHeight = headerDisclosureContent?.getBoundingClientRect().height;
      headerDisclosureAnimation?.cancel();
      headerDisclosureAnimation = null;
      if (!expanded && headerDisclosure.contains(document.activeElement)) {
        headerDisclosureToggle.focus({ preventScroll: true });
      }
      if (expanded) headerDisclosure.classList.add('is-expanded');
      headerDisclosureToggle.setAttribute('aria-expanded', String(expanded));
      headerDisclosureToggle.textContent = expanded
        ? headerDisclosureToggle.dataset.expandedLabel
        : headerDisclosureToggle.dataset.collapsedLabel;
      headerDisclosure.querySelectorAll('a').forEach((link) => {
        if (expanded) {
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
        }
      });
      if (!headerDisclosureContent) return;

      const collapsedHeight = Number.parseFloat(getComputedStyle(headerDisclosureContent).lineHeight);
      const targetHeight = expanded ? headerDisclosureContent.scrollHeight : collapsedHeight;
      if (!animate || prefersReducedMotion.matches || startHeight === targetHeight) {
        headerDisclosureContent.style.height = expanded ? 'auto' : `${collapsedHeight}px`;
        headerDisclosure.classList.toggle('is-expanded', expanded);
        return;
      }

      headerDisclosureAnimation = headerDisclosureContent.animate(
        { height: [`${startHeight}px`, `${targetHeight}px`] },
        {
          duration: blockingSurfaceTransitionDuration,
          easing: blockingSurfaceTransitionEasing,
          fill: 'both',
        }
      );
      headerDisclosureAnimation.addEventListener('finish', () => {
        headerDisclosureContent.style.height = expanded ? 'auto' : `${collapsedHeight}px`;
        headerDisclosure.classList.toggle('is-expanded', expanded);
        headerDisclosureAnimation?.cancel();
        headerDisclosureAnimation = null;
      }, { once: true });
    };

    headerDisclosureToggle?.addEventListener('click', () => {
      setHeaderDisclosureExpanded(headerDisclosureToggle.getAttribute('aria-expanded') !== 'true');
    });

    headerDisclosure?.addEventListener('click', (event) => {
      if (headerDisclosureToggle?.getAttribute('aria-expanded') !== 'true' && event.target.closest('a')) {
        event.preventDefault();
      }
    });

    setHeaderDisclosureExpanded(false, false);

    const closeModal = (isExplicitClose = true) => {
      if (!isModalOpen) return;

      trackChatEnd(isExplicitClose);

      const returnsToWelcome = canShowWelcomePreview();

      cancelRecommendationPreparation();
      clearRecommendationFeedback();
      clearRecommendationBuyBox();
      setHeaderDisclosureExpanded(false, false);
      isModalOpen = false;
      isModalOpening = false;
      setSubmissionEnabled(!isExchangeInFlight);
      updateAnimatedPlaceholderVisibility();
      isModalTransitioning = true;
      el.classList.remove('is-modal-content-visible');
      el.classList.add('is-modal-transitioning');
      setStatus('');
      trackVisualViewport(false);
      // Dismiss the on-screen keyboard while the box closes
      if (isTouchInput() && el.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      const closingTrigger = activeTrigger;
      activeTrigger = null;
      // On touch, refocusing the input would raise the keyboard again
      const blursEntryInput =
        closingTrigger === input && ((!hasStarted && historyState === 'none') || isTouchInput());

      const releasePage = () => {
        document.documentElement.style.overflow = previousDocumentOverflow;
        setPageAvailability(true);

        if (blursEntryInput) {
          input.blur();
          return;
        }

        const focusTarget = canRestoreFocusTo(closingTrigger)
          ? closingTrigger
          : canRestoreFocusTo(heroEntryTrigger)
            ? heroEntryTrigger
            : canRestoreFocusTo(trigger)
              ? trigger
              : null;
        if (focusTarget) {
          isRestoringFocus = true;
          focusTarget.focus({ preventScroll: true });
          isRestoringFocus = false;
        }
      };

      // An opening buy box takes over the backdrop and scroll lock straight away
      if (!isExplicitClose) {
        if (overlay) overlay.classList.remove('is-visible');
        releasePage();
      } else {
        el.classList.add('is-modal-closing');
      }

      const finishClosing = () => {
        clearVisualViewport();
        restorePassivePresentation();
        el.classList.remove('is-modal-transitioning');
        applyNekuaAiWelcomePolicy();
        announceProductSurface('ai-box:closed');

        if (!isExplicitClose) {
          isModalTransitioning = false;
          modalTransitionTimer = null;
          return;
        }

        // Backdrop-last dismissal: the page returns only after the backdrop fade
        if (overlay) overlay.classList.remove('is-visible');
        modalTransitionTimer = window.setTimeout(() => {
          el.classList.remove('is-modal-closing');
          releasePage();
          isModalTransitioning = false;
          modalTransitionTimer = null;
        }, blockingSurfaceContentTransitionDuration);
      };

      window.requestAnimationFrame(() => {
        const modalHeight = el.getBoundingClientRect().height;
        el.style.maxHeight = `${modalHeight}px`;
        el.classList.remove('is-modal-open');
        el.removeAttribute('role');
        el.removeAttribute('aria-modal');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (welcomePreviewTrigger) welcomePreviewTrigger.setAttribute('aria-expanded', 'false');
        if (heroEntryTrigger) heroEntryTrigger.setAttribute('aria-expanded', 'false');
        el.classList.remove('is-input-focused');
        syncWelcomeMediaPlayback();
        updateConversationHeader();

        if (returnsToWelcome) {
          const welcomeHeight = el.getBoundingClientRect().height;
          el.style.height = `${modalHeight}px`;
          void el.offsetHeight;
          window.requestAnimationFrame(() => {
            el.style.height = `${welcomeHeight}px`;
            modalTransitionTimer = window.setTimeout(() => {
              el.style.height = '';
              el.style.maxHeight = '';
              finishClosing();
            }, prefersReducedMotion.matches ? 0 : blockingSurfaceTransitionDuration);
          });
          return;
        }

        collapse();

        modalTransitionTimer = window.setTimeout(() => {
          el.style.maxHeight = '';
          finishClosing();
        }, prefersReducedMotion.matches ? 0 : blockingSurfaceTransitionDuration);
      });
    };

    const trapFocus = (event) => {
      if (!isModalOpen || event.key !== 'Tab') return;

      const focusable = Array.from(el.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((node) => !node.hidden && node.getClientRects().length);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const resizeInput = () => {
      if (!input) return;
      input.style.height = 'auto';
      input.style.height = `${input.scrollHeight}px`;
    };

    const scrollConversationToBottom = () => {
      if (!contentInner) return;
      const setScrollPosition = () => {
        contentInner.scrollTop = contentInner.scrollHeight;
      };

      setScrollPosition();
      requestAnimationFrame(() => {
        setScrollPosition();
        window.setTimeout(setScrollPosition, 450);
      });
    };

    // Reset the intro (title/description) the first time a message is shown.
    const clearIntro = () => {
      if (!hasStarted) {
        contentBody.innerHTML = '';
        hasStarted = true;
      }
      el.classList.remove('is-welcome');
      updateAnimatedPlaceholderVisibility();
      updateConversationHeader();
    };

    const updateConversationHeader = () => {
      if (!conversationHeader) return;
      const showsInitialQuestions = isModalOpen && historyState === 'none' && !hasStarted;
      const showsConversation = isModalOpen && hasStarted && historyState !== 'pending';
      conversationHeader.hidden = !(showsInitialQuestions || showsConversation);
    };

    // Render assistant text as sanitized markdown when the libraries are loaded.
    const renderMarkdown = (target, text) => {
      if (!target) return;
      const value = typeof text === 'string' ? text : '';
      if (typeof marked !== 'undefined' && typeof DOMPurify !== 'undefined') {
        target.innerHTML = DOMPurify.sanitize(marked.parse(value));
        openPageLinksInNewTab(target);
      } else {
        target.textContent = value;
      }
    };

    const stripEmoji = (text) =>
      typeof text === 'string'
        ? text.replace(
            /[#*0-9]\uFE0F?\u20E3|[\u{1F1E6}-\u{1F1FF}]{2}|\p{Extended_Pictographic}(?:\uFE0F|\uFE0E)?\p{Emoji_Modifier}?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\uFE0E)?\p{Emoji_Modifier}?)*|[\u{E0020}-\u{E007E}]+\u{E007F}/gu,
            ''
          )
        : '';

    // Sent message: black bubble aligned to the right.
    const appendQuestion = (text) => {
      clearIntro();
      const questionEl = document.createElement('div');
      questionEl.className = 'ai-box__question';
      const bubbleEl = document.createElement('div');
      bubbleEl.className = 'ai-box__question-bubble';
      bubbleEl.textContent = text;
      questionEl.appendChild(bubbleEl);
      contentBody.appendChild(questionEl);
    };

    // Answer: left-aligned response text.
    const appendAnswer = (text) => {
      clearIntro();
      const answerEl = document.createElement('div');
      answerEl.className = 'ai-box__answer';
      const responseEl = document.createElement('div');
      responseEl.className = 'ai-box__response';
      if (text != null) renderMarkdown(responseEl, stripEmoji(text));
      answerEl.appendChild(responseEl);
      contentBody.appendChild(answerEl);
      return answerEl;
    };

    // Parse the follow_up_questions payload from a StepOutput content string.
    // The content is a Python-style dict repr, so questions are extracted via regex.
    const extractFollowUpQuestions = (content) => {
      if (typeof content !== 'string' || content.indexOf('follow_up_questions') === -1) {
        return null;
      }
      const listMatch = content.match(/["']questions["']\s*:\s*\[([\s\S]*?)\]/);
      if (!listMatch) return null;

      const questions = [];
      const re = /'((?:[^'\\]|\\.)*)'|"((?:[^"\\]|\\.)*)"/g;
      let match;
      while ((match = re.exec(listMatch[1])) !== null) {
        const value = (match[1] !== undefined ? match[1] : match[2])
          .replace(/\\(['"])/g, '$1')
          .trim();
        if (value) questions.push(value);
      }
      return questions.length ? questions : null;
    };

    // Follow-up question pills, shown under the latest answer only.
    const appendFollowUps = (answerEl, questions) => {
      if (!answerEl || !questions || !questions.length) return;

      const hintsEl = document.createElement('div');
      hintsEl.className = 'ai-box__hints';

      questions.forEach((question, questionIndex) => {
        const hintButton = document.createElement('button');
        hintButton.type = 'button';
        hintButton.className = 'ai-box__hint';

        const hintText = document.createElement('span');
        hintText.className = 'ai-box__hint-text';
        hintText.textContent = question;
        hintButton.appendChild(hintText);

        const iconSvg = submitButton && submitButton.querySelector('svg');
        if (iconSvg) {
          const iconWrap = document.createElement('span');
          iconWrap.className = 'ai-box__hint-icon';
          iconWrap.appendChild(iconSvg.cloneNode(true));
          hintButton.appendChild(iconWrap);
        }

        // Clicking injects the question into the input and submits it.
        hintButton.addEventListener('click', () => {
          if (!input) return;
          pushChatbotInteraction('option_click', {
            option_position: questionIndex + 1,
            ui_variant: 'follow_up',
          });
          input.value = question;
          submit(false);
        });

        hintsEl.appendChild(hintButton);
      });

      const placeholder = answerEl.querySelector('.ai-box__follow-ups-skeleton');
      if (placeholder) {
        placeholder.replaceWith(hintsEl);
      } else {
        answerEl.appendChild(hintsEl);
      }
      scrollConversationToBottom();
    };

    const appendAnswerSkeleton = (answerEl, type) => {
      if (!answerEl || answerEl.querySelector(`.ai-box__${type}-skeleton`)) return;

      const skeleton = document.createElement('div');
      skeleton.className = `ai-box__${type}-skeleton`;
      skeleton.setAttribute('aria-hidden', 'true');

      if (type === 'products') {
        skeleton.innerHTML = `
          <span class="ai-box__skeleton-line ai-box__skeleton-line--title"></span>
          <span class="ai-box__skeleton-products">
            <span class="ai-box__skeleton-product"></span>
            <span class="ai-box__skeleton-product"></span>
            <span class="ai-box__skeleton-product"></span>
          </span>
        `;
      } else {
        skeleton.innerHTML = `
          <span class="ai-box__skeleton-line ai-box__skeleton-line--question"></span>
          <span class="ai-box__skeleton-line ai-box__skeleton-line--question ai-box__skeleton-line--short"></span>
        `;
      }

      if (type === 'products') {
        answerEl.insertBefore(skeleton, answerEl.firstChild);
      } else {
        answerEl.appendChild(skeleton);
      }
      scrollConversationToBottom();
    };

    // Product recommendation cards (max 3), rendered at the top of the answer.
    const appendProducts = (answerEl, products) => {
      if (!answerEl || !products || !products.length) return;

      const titleEl = document.createElement('p');
      titleEl.className = 'ai-box__recommend-title';
      titleEl.textContent = uiLabels.recommendTitle;

      const productsEl = document.createElement('div');
      productsEl.className = 'ai-box__products';

      const visibleProducts = products.slice(0, 3);

      void Promise.all(
        visibleProducts.map((product) => resolveRecommendationProductId(getRecommendationHandle(product)))
      ).then(() => {
        const listItems = visibleProducts
          .map((product, index) => {
            const item = getRecommendationItem(product);
            return item ? withRecommendationListContext(item, index) : null;
          })
          .filter(Boolean);
        if (!listItems.length) return;

        pushAiEvent({
          event: 'view_item_list',
          ecommerce: { ...RECOMMENDATION_LIST, items: listItems },
        });
      });

      visibleProducts.forEach((product, productIndex) => {
        if (!product) return;

        // Only allow http(s) or root-relative product urls.
        const url = typeof product.product_url === 'string' ? product.product_url : '';
        const safeUrl = /^(https?:\/\/|\/)/.test(url) ? url : '#';

        const card = document.createElement('div');
        card.className = 'ai-box__product-card';
        const trackRecommendationItemClick = () => {
          const item = getRecommendationItem(product);
          if (!item) return;

          const ecommerce = {
            ...RECOMMENDATION_LIST,
            items: [withRecommendationListContext(item, productIndex)],
          };
          pushChatbotInteraction('item_click', {
            item_id: item.item_id,
            item_name: item.item_name,
            action_text: item.item_name,
            price: item.price,
          });
          pushAiEvent({
            event: 'select_item',
            ecommerce,
          });
        };

        if (product.image_url) {
          const mediaLink = document.createElement('a');
          mediaLink.className = 'ai-box__product-link';
          mediaLink.href = safeUrl;
          mediaLink.addEventListener('click', () => trackRecommendationItemClick());

          const media = document.createElement('div');
          media.className = 'ai-box__product-media';
          const img = document.createElement('img');
          img.src = product.image_url;
          img.alt = product.title || '';
          img.loading = 'lazy';
          media.appendChild(img);
          mediaLink.appendChild(media);
          card.appendChild(mediaLink);
        }

        const info = document.createElement('div');
        info.className = 'ai-box__product-info';

        const name = document.createElement('a');
        name.className = 'ai-box__product-link ai-box__product-title';
        name.href = safeUrl;
        const handle = getRecommendationHandle(product);
        if (handle) {
          resolveRecommendationDisplayName(handle).then((displayName) => {
            name.textContent = displayName || product.title || '';
          });
        } else {
          name.textContent = product.title || '';
        }
        name.addEventListener('click', () => trackRecommendationItemClick());
        info.appendChild(name);

        const price = product.price_min;
        if (price != null && price !== '') {
          const priceLink = productPriceTemplate
            ? productPriceTemplate.content.firstElementChild.cloneNode(true)
            : document.createElement('a');
          priceLink.classList.add('ai-box__product-price', 'cta-link');
          priceLink.href = safeUrl;
          priceLink.textContent = `${uiLabels.pricePrefix} \u20AC${price}`.trim();
          if (!product.handle && handle) {
            console.debug('[ai-box][recommendation] derived product handle from URL', {
              handle,
              url,
            });
          }
          priceLink.dataset.recommendationHandle = handle;
          priceLink.addEventListener('click', (event) => {
            event.preventDefault();
            if (priceLink.getAttribute('aria-disabled') === 'true') return;
            trackRecommendationItemClick();
            openRecommendationBuyBox(handle, priceLink);
          });
          info.appendChild(priceLink);
        }

        card.appendChild(info);
        productsEl.appendChild(card);
      });

      const placeholder = answerEl.querySelector('.ai-box__products-skeleton');
      if (placeholder) {
        placeholder.replaceWith(titleEl, productsEl);
      } else {
        answerEl.insertBefore(productsEl, answerEl.firstChild);
        answerEl.insertBefore(titleEl, answerEl.firstChild);
      }
      scrollConversationToBottom();
    };

    const saveRecommendationProducts = (conversationIdToSave, assistantIndex, products) => {
      if (!conversationIdToSave || !Array.isArray(products) || !products.length) return;

      try {
        const key = `nekua_ai_recommendations:${tenant_id}:${conversationIdToSave}`;
        const recommendations = readRecommendationProducts(conversationIdToSave);
        recommendations[assistantIndex] = products.slice(0, 3);
        const recentRecommendations = Object.fromEntries(Object.entries(recommendations).slice(-50));
        window.sessionStorage.setItem(key, JSON.stringify(recentRecommendations));
      } catch (error) {
        console.error('Failed to save recommendation products:', error);
      }
    };

    const readRecommendationProducts = (conversationIdToLoad) => {
      try {
        const key = `nekua_ai_recommendations:${tenant_id}:${conversationIdToLoad}`;
        const recommendations = JSON.parse(window.sessionStorage.getItem(key) || '{}');
        return recommendations && typeof recommendations === 'object' && !Array.isArray(recommendations)
          ? recommendations
          : {};
      } catch (error) {
        console.error('Failed to read recommendation products:', error);
        return {};
      }
    };

    // Load an existing conversation before the visitor can submit another message.
    const loadChat = async (chatIdToLoad) => {
      try {
        const res = await fetch(`${CHATS_ENDPOINT}/${chatIdToLoad}`, {
          method: 'GET',
          headers: { 'x-org-id': tenant_id },
        });

        if (!res.ok) {
          console.error('Failed to load chat:', res.status);
          if (isGuestConversation && (res.status === 404 || res.status === 410)) {
            try {
              window.localStorage.removeItem(guestConversationStorageKey);
            } catch (error) {
              console.error('Failed to clear guest conversation id:', error);
            }
            restoreFreshConversation();
            return;
          }
          showHistoryError(() => loadChat(chatIdToLoad));
          return;
        }

        const data = await res.json();
        chatId = data?.id || data?._id || data?.chat_id || chatIdToLoad;

        if (!contentBody) return;
        clearIntro();
        const messages = data?.messages || data?.chat?.messages || data?.data?.messages || [];
        const recommendations = readRecommendationProducts(chatId);
        let assistantIndex = 0;

        messages.forEach((msg) => {
          if (!msg || !msg.content) return;
          conversationMessages.push({ role: msg.role, content: msg.content });
          if (msg.role === 'user') {
            appendQuestion(msg.content);
          } else {
            const answerEl = appendAnswer(msg.content);
            if (msg.role === 'assistant') {
              const products = recommendations[assistantIndex];
              if (Array.isArray(products)) appendProducts(answerEl, products);
              assistantIndex += 1;
            }
          }
        });

        historyState = 'ready';
  updateConversationHeader();
        setMessagingEnabled(true);
        setStatus('Conversazione caricata');
        scrollConversationToBottom();
      } catch (error) {
        console.error('Failed to load chat:', error);
        showHistoryError(() => loadChat(chatIdToLoad));
      }
    };

    const saveConversationId = async (conversationIdToSave) => {
      if (!conversationIdToSave) return;

      if (!isLoggedIn) {
        try {
          window.localStorage.setItem(guestConversationStorageKey, conversationIdToSave);
        } catch (error) {
          console.error('Failed to save guest conversation id:', error);
          throw error;
        }
        hasSavedConversation = true;
        updateAnimatedPlaceholderVisibility();
        return;
      }

      if (storedConversationId || !conversationSaveUrl || !customerSecretKey) return;

      try {
        const response = await fetch(conversationSaveUrl, {
          method: 'POST',
          headers: {
            Authorization: customerSecretKey,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ conversation_id: conversationIdToSave }),
        });

        if (!response.ok) {
          throw new Error(`Failed to save conversation id: ${response.status}`);
        }
        hasSavedConversation = true;
        updateAnimatedPlaceholderVisibility();
      } catch (error) {
        console.error('Failed to save conversation id:', error);
        throw error;
      }
    };

    const schedulePersistenceRetry = () => {
      if (persistenceRetryTimer || !persistenceQueue.length) return;
      const exchange = persistenceQueue[0];
      const delay = persistenceRetryDelays[exchange.retryAttempt];

      if (delay === undefined) {
        isPersistenceRetryExhausted = true;
        updatePersistenceStatus('Salvataggio in sospeso. Riprova quando vuoi.', true);
        return;
      }

      exchange.retryAttempt += 1;
      updatePersistenceStatus('Salvataggio in sospeso. Riprovo automaticamente.');
      persistenceRetryTimer = window.setTimeout(() => {
        persistenceRetryTimer = null;
        processPersistenceQueue();
      }, delay);
    };

    const processPersistenceQueue = async () => {
      if (isPersisting || !persistenceQueue.length || isPersistenceRetryExhausted || !navigator.onLine) {
        if (persistenceQueue.length && !navigator.onLine) {
          updatePersistenceStatus('Salvataggio in sospeso. Riprenderà quando torni online.');
        }
        return;
      }

      isPersisting = true;
      const exchange = persistenceQueue[0];

      try {
        if (!exchange.createdConversationId) {
          const isFirst = !chatId;
          const response = await fetch(isFirst ? CHATS_ENDPOINT : `${CHATS_ENDPOINT}/${chatId}`, {
            method: isFirst ? 'POST' : 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'x-org-id': tenant_id,
            },
            body: JSON.stringify({ messages: exchange.messages, current_url: window.location.href }),
          });

          if (!response.ok) throw new Error(`Failed to persist chat: ${response.status}`);

          if (isFirst) {
            const { data: chat } = await response.json();
            const createdChatId = chat?._id || chat?.id || chat?.chat_id || null;
            if (!createdChatId) throw new Error('Persisted chat did not return an ID');
            chatId = createdChatId;
            exchange.createdConversationId = createdChatId;
          }
        }

        saveRecommendationProducts(chatId, exchange.assistantIndex, exchange.products);

        if (exchange.createdConversationId) {
          await saveConversationId(exchange.createdConversationId);
        }

        persistenceQueue.shift();
        updatePersistenceStatus(persistenceQueue.length ? 'Salvataggio in corso.' : '');
      } catch (error) {
        console.error('Failed to persist chat:', error);
        schedulePersistenceRetry();
      } finally {
        isPersisting = false;
      }

      if (persistenceQueue.length && !persistenceRetryTimer && !isPersistenceRetryExhausted) {
        processPersistenceQueue();
      }
    };

    const enqueuePersistence = (message, reply, userTimestamp, assistantTimestamp, products) => {
      const assistantIndex = conversationMessages.filter((message) => message.role === 'assistant').length - 1;
      saveRecommendationProducts(chatId, assistantIndex, products);
      persistenceQueue.push({
        messages: [
          { role: 'user', content: message, timestamp: userTimestamp },
          { role: 'assistant', content: reply, timestamp: assistantTimestamp },
        ],
        assistantIndex,
        products,
        retryAttempt: 0,
      });
      updatePersistenceStatus('Salvataggio in corso.');
      processPersistenceQueue();
    };

    const sendMessage = async (message, failedAnswerEl, failedUserMessage) => {
      if (isExchangeInFlight) return;

      isExchangeInFlight = true;
      setSubmissionEnabled(false);
      const isRetry = Boolean(failedAnswerEl);
      const userTimestamp = new Date().toISOString();
      const userMessage = failedUserMessage || { role: 'user', content: message };
      if (!isRetry) conversationMessages.push(userMessage);
      let answerEl = failedAnswerEl || null;
      let responseEl = answerEl && answerEl.querySelector('.ai-box__response');
      let thinkingEl = null;
      let responseOutcomeTracked = false;

      const trackResponseOutcome = (outcome) => {
        if (responseOutcomeTracked) return;
        responseOutcomeTracked = true;
        pushChatbotInteraction('response_displayed', { response_outcome: outcome });
      };

      if (contentBody) {
        if (!isRetry) {
          contentBody.querySelectorAll('.ai-box__hints').forEach((node) => node.remove());
          appendQuestion(message);
          answerEl = appendAnswer();
          responseEl = answerEl.querySelector('.ai-box__response');
        } else if (responseEl) {
          responseEl.textContent = '';
        }

        if (thinkingTemplate && thinkingTemplate.content.firstElementChild) {
          thinkingEl = thinkingTemplate.content.firstElementChild.cloneNode(true);
          answerEl.insertBefore(thinkingEl, responseEl);
          const thinkingVideo = thinkingEl.querySelector('video');
          if (thinkingVideo && !prefersReducedMotion.matches) {
            thinkingVideo.muted = true;
            thinkingVideo.playsInline = true;
            thinkingVideo.play().catch(() => {});
          }
        }
        setStatus('Sto riflettendo');
        expand();
        scrollConversationToBottom();
      }

      try {
        const response = await fetch(COMPLETIONS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            tenant_id: tenant_id,
            ...(chatId && { conversation_id: chatId }),
            channel: 'onsite',
            stream: true,
            messages: conversationMessages,
            page_context: { url: window.location.href },
            language: 'it',
          }),
        });

        if (!response.ok || !response.body) {
          throw new Error(`AI request failed: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let fullContent = '';
        let followUpQuestions = null;
        let recommendedProducts = null;
        let followUpsSkeletonShown = false;
        let productsSkeletonShown = false;

        const processStreamLine = (line) => {
          const trimmed = line.trim();
          if (!trimmed.startsWith('data:')) return;

          const data = trimmed.slice(5).trim();
          if (!data || data === '[DONE]' || !data.startsWith('{')) return;

          try {
            const chunk = JSON.parse(data);

            if (chunk?.metadata?.step_name === 'follow_up_questions') {
              const questions = extractFollowUpQuestions(chunk?.choices?.[0]?.delta?.content);
              if (questions) {
                followUpQuestions = questions;
                if (!followUpsSkeletonShown) {
                  appendAnswerSkeleton(answerEl, 'follow-ups');
                  followUpsSkeletonShown = true;
                }
              }
              return;
            }

            const rawContent = chunk?.choices?.[0]?.delta?.content;

            if (
              typeof rawContent === 'string' &&
              rawContent.indexOf('product_recommendations_completed') !== -1
            ) {
              try {
                const payload = JSON.parse(rawContent);
                if (
                  payload?.event === 'product_recommendations_completed' &&
                  Array.isArray(payload.products)
                ) {
                  recommendedProducts = payload.products;
                  if (recommendedProducts.length && !productsSkeletonShown) {
                    appendAnswerSkeleton(answerEl, 'products');
                    productsSkeletonShown = true;
                  }
                }
              } catch (error) {
                console.error('Failed to parse products:', error);
              }
              return;
            }

            if (chunk?.metadata?.event !== 'TeamRunContent' || !rawContent) return;

            if (thinkingEl) {
              thinkingEl.remove();
              thinkingEl = null;
            }
            fullContent += stripEmoji(rawContent);
            if (responseEl) {
              renderMarkdown(responseEl, fullContent);
              scrollConversationToBottom();
            }
          } catch (error) {
            console.error('Failed to parse chunk:', data, error);
          }
        };

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';
          lines.forEach(processStreamLine);
        }

        buffer += decoder.decode();
        if (buffer) processStreamLine(buffer);

        if (!fullContent) {
          trackResponseOutcome('no_match');
          throw new Error('AI stream completed without answer content');
        }

        if (thinkingEl) thinkingEl.remove();
        setStatus('Risposta completata');
        trackResponseOutcome('success');
        appendProducts(answerEl, recommendedProducts);
        appendFollowUps(answerEl, followUpQuestions);
        answerEl?.querySelectorAll('.ai-box__products-skeleton, .ai-box__follow-ups-skeleton').forEach((node) => node.remove());

        const assistantTimestamp = new Date().toISOString();
        conversationMessages.push({ role: 'assistant', content: fullContent });
        enqueuePersistence(message, fullContent, userTimestamp, assistantTimestamp, recommendedProducts);
        failedExchange = null;
        isExchangeInFlight = false;
        setSubmissionEnabled(true);
      } catch (error) {
        console.error('AI request failed:', error);
        trackResponseOutcome('error');
        if (thinkingEl) thinkingEl.remove();
        if (answerEl) {
          const errorEl = document.createElement('div');
          errorEl.className = 'ai-box__exchange-error';
          const errorText = document.createElement('p');
          errorText.textContent = uiLabels.answerError;
          const retryButton = document.createElement('button');
          retryButton.type = 'button';
          retryButton.className = 'ai-box__hint';
          retryButton.textContent = uiLabels.retry;
          retryButton.addEventListener('click', () => {
            errorEl.remove();
            const retryUserMessage = failedExchange && failedExchange.userMessage;
            failedExchange = null;
            sendMessage(message, answerEl, retryUserMessage);
          });
          errorEl.append(errorText, retryButton);
          answerEl.appendChild(errorEl);
          failedExchange = { errorEl, userMessage };
        }
        setStatus('Impossibile completare la risposta. Riprova.');
        isExchangeInFlight = false;
        setSubmissionEnabled(true);
        scrollConversationToBottom();
      }
    };

    const submit = (trackMessage = true) => {
      if (!input || input.disabled || isExchangeInFlight || !input.value.trim()) return;
      const message = input.value.trim();
      if (trackMessage) {
        pushChatbotInteraction('message_submit', {
          input_method: 'free_text',
        });
      }
      if (failedExchange) {
        failedExchange.errorEl.remove();
        const failedMessageIndex = conversationMessages.indexOf(failedExchange.userMessage);
        if (failedMessageIndex !== -1) conversationMessages.splice(failedMessageIndex, 1);
        failedExchange = null;
      }
      input.value = '';
      resizeInput();
      updateAnimatedPlaceholderVisibility();
      sendMessage(message);
    };

    // Third-party dialogs (e.g. Klaviyo) restore focus to the nearest field on close; ignore focus the user didn't start here
    document.addEventListener('pointerdown', (event) => {
      lastPointerTarget = event.target;
      lastKey = '';
      lastInteractionTime = performance.now();
    }, true);
    document.addEventListener('keydown', (event) => {
      lastKey = event.key;
      lastPointerTarget = null;
      lastInteractionTime = performance.now();
    }, true);
    const resetInteraction = () => {
      lastPointerTarget = null;
      lastKey = '';
    };
    // The interaction only vouches for the next focus change
    document.addEventListener('focusin', (event) => {
      if (event.target !== input) resetInteraction();
    }, true);
    const isUserFocus = () => {
      const isRecent = performance.now() - lastInteractionTime < 1000;
      const isUser = isRecent && (lastKey === 'Tab' || (lastPointerTarget instanceof Node && el.contains(lastPointerTarget)));
      resetInteraction();
      return isUser;
    };

    if (input) {
      input.addEventListener('input', () => {
        resizeInput();
        updateAnimatedPlaceholderVisibility();
      });
      input.addEventListener('focus', () => {
        const isUserInitiated = isUserFocus();
        updateAnimatedPlaceholderVisibility();
        // A tap on the collapsed field while it is still closing must not leave the keyboard up
        if (el.classList.contains('is-modal-closing')) {
          input.blur();
          return;
        }
        if (!isModalOpen && !isRestoringFocus) {
          if (!isUserInitiated) {
            input.blur();
            return;
          }
          openModal(input, el.classList.contains('is-expanded') ? 'inline_input' : 'floating_widget');
        }
      });
      input.addEventListener('blur', updateAnimatedPlaceholderVisibility);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          submit();
        }
      });
    }

    if (submitButton) {
      submitButton.addEventListener('click', submit);
    }

    if (trigger) {
      trigger.addEventListener('click', () => openModal(trigger, 'floating_widget'));
    }

    if (welcomePreviewTrigger) {
      welcomePreviewTrigger.addEventListener('click', () => {
        openModal(welcomePreviewTrigger, 'welcome_preview');
      });
    }

    if (heroEntryTrigger) {
      heroEntryTrigger.addEventListener('click', () => {
        openModal(heroEntryTrigger, 'hero_entry');
        // iOS opens the keyboard only for a focus() made during the tap
        if (isTouchInput() && isModalOpen && input && !input.disabled) input.focus({ preventScroll: true });
      });
    }

    if (contentBody) {
      contentBody.addEventListener('click', (event) => {
        const questionButton = event.target.closest('.ai-box__welcome-question');
        if (!questionButton) {
          const supportLink = event.target.closest('a[href^="mailto:"]');
          if (supportLink) {
            pushChatbotInteraction('human_support_requested', {
              input_method: 'email_link_click',
            });
          }
          return;
        }
        if (!input || isExchangeInFlight) return;
        const welcomeQuestions = Array.from(
          contentBody.querySelectorAll('.ai-box__welcome-question')
        );
        pushChatbotInteraction('option_click', {
          option_position: welcomeQuestions.indexOf(questionButton) + 1,
          ui_variant: 'welcome_question',
        });
        openModal(questionButton, 'welcome_question');
        input.value = questionButton.dataset.aiQuestion || '';
        updateAnimatedPlaceholderVisibility();
        submit(false);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => {
        closeModal();
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => closeModal(true));
    }

    document.addEventListener('buy-box:opening', handleBuyBoxOpening);
    window.addEventListener('pagehide', () => {
      trackChatEnd(false);
      document.removeEventListener('buy-box:opening', handleBuyBoxOpening);
      if (placeholderRotationTimer) window.clearInterval(placeholderRotationTimer);
      if (placeholderTransitionTimer) window.clearTimeout(placeholderTransitionTimer);
    }, { once: true });

    window.addEventListener('online', () => {
      if (persistenceRetryTimer) {
        window.clearTimeout(persistenceRetryTimer);
        persistenceRetryTimer = null;
      }
      if (persistenceQueue.length) {
        persistenceQueue[0].retryAttempt = 0;
        isPersistenceRetryExhausted = false;
        updatePersistenceStatus('Salvataggio in corso.');
        processPersistenceQueue();
      }
    });

    document.addEventListener('keydown', (event) => {
      const recommendationBuyBoxOpen = document.querySelector(
        'buy-box-panel[data-recommendation-buy-box][role="dialog"]'
      );
      if (event.key === 'Escape' && !recommendationBuyBoxOpen) {
        closeModal();
      }
      trapFocus(event);
    });

    setMessagingEnabled(!hasSavedConversation);

    // Load the existing conversation for customers and guests with a stored ID.
    if (conversationId) {
      chatId = conversationId;
      loadChat(conversationId);
    }

    if (el.dataset.welcomeEnabled === 'true') {
      window.addEventListener('scroll', () => {
        if (pagePolicy !== 'home') return;
        const isAtHomepageTop = window.scrollY <= 16;
        if (isAtHomepageTop === wasAtHomepageTop) return;
        wasAtHomepageTop = isAtHomepageTop;
        applyWelcomePreviewPolicy();
      }, { passive: true });
    }

    if (heroSection) {
      const heroObserver = new IntersectionObserver((entries) => {
        isHeroInView = entries.some((entry) => entry.isIntersecting);
        applyNekuaAiWelcomePolicy();
      });
      heroObserver.observe(heroSection);
    }

    updateAnimatedPlaceholderVisibility();
    applyWelcomePreviewPolicy();
    applyNekuaAiWelcomePolicy();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appstle-fixed-pricing-host"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shopify-section--appstle-fixed-pricing-host').forEach((section) => {
    section.setAttribute('aria-hidden', 'true');
    section.inert = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nekua-ai-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-nekua-ai-hero]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('video').forEach((video) => {
      video.play().catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
